<template>
    <!-- REQUEST NOTIFICATION PERMISSION -->
    <popup-modal v-if="requestNotificationPermission || unableToGrantPermission" show style="z-index:300">
        <template #content>
            <div class="message">
                <h3>Notificaties ontvangen</h3>
                <div v-if="unableToGrantPermission">
                    <br>
                    <p >Je kan geen notificaties ontvangen omdat jouw browser dit niet toestaat, pas je browser instellingen aan</p>
                    <br>
                </div>
                <div v-else>
                    <br>
                    <p>Beheer alle notificaties zelf onder</p>
                    <p><strong>Menu > Profiel & instellingen</strong></p>
                    <br>
                    <p style="font-size:14px;font-style:italic;">*Je kan dit altijd nog uit zetten</p>
                </div>
            </div>
        </template>
        <template #footer>
            <custom-button v-if="requestNotificationPermission && unableToGrantPermission" @click="handleDenyPermission">Ik wil echt geen notificaties 🙈</custom-button>
            <custom-button v-else-if="requestNotificationPermission" @click="handleRequestPermission">Geef toestemming</custom-button>
            <custom-button v-else @click="handleDenyPermission">Begrepen</custom-button>
        </template>
    </popup-modal>
</template>

<script>
import PopupModal from '@/components/PopupModal.vue';
import CustomButton from '@/components/CustomButton.vue';

export default {
    name: 'notification-permissions',
    components: {
        PopupModal,
        CustomButton,
    },
    data() {
        return {
            requestNotificationPermission: false,
            unableToGrantPermission: false,
            timesRequested: 0,
            callbackFunction: null,
        }
    },
    methods: {
        async handleGrantpermission() {
            this.unableToGrantPermission = false;
            this.notificationsDenied = false;
            this.requestNotificationPermission = false;
            await this.initializeSubscription();
            localStorage.removeItem('notificationPermissionDenied');
            if (this.callbackFunction) this.callbackFunction(true);
            this.callbackFunction = null;
        },
        handleDenyPermission() {
            this.unableToGrantPermission = false;
            this.requestNotificationPermission = false;
            this.notificationsDenied = true;
            if (this.callbackFunction) this.callbackFunction(false);
            this.callbackFunction = null;
            localStorage.setItem('notificationPermissionDenied', true);
        },

        async handleRequestNotificationPermission(callbackFunction) {
            this.callbackFunction = callbackFunction;
            if ('Notification' in window && Notification.permission === 'granted') return await this.handleGrantpermission();


            this.requestNotificationPermission = true;
        },

        handleRequestPermission() {
            if (!'Notification' in window) return this.handleDenyPermission();
            this.timesRequested++;

            if (this.timesRequested > 1) return this.unableToGrantPermission = true;

            Notification.requestPermission()
                .then(permission => {
                    if (permission === 'granted') this.handleGrantpermission();
                    if (permission === 'denied') this.handleDenyPermission();
                });
        },
        
        async checkNotificationPermission(overwrite = false) {
            this.notificationsDenied = !!localStorage.getItem('notificationPermissionDenied');
            if (!'Notification' in window || (this.notificationsDenied && !overwrite)) return this.handleDenyPermission();

            // wait for service worker to be ready
            await navigator.serviceWorker.ready;

            if (Notification.permission === "granted") return true;

            if (Notification.permission === "denied") this.unableToGrantPermission = true;
            else if (Notification.permission !== "granted") this.requestNotificationPermission = true;
            else this.handleRequestPermission();

            return false;
        },
        async initializeSubscription() {
            let user = JSON.parse(localStorage.getItem('you'));
            
            const registration = await navigator.serviceWorker.ready;
            
            let subscription = await registration.pushManager.getSubscription();
            if (subscription && subscription.endpoint === user.subscription?.endpoint) return console.log('[Debug] Subscription already exists');
            
            if (!subscription) subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: "BJkUbpYqUNY-mwLfJffmjwmFM7Ktoau_noLM8L_re1-n6qwg50dODYSHfhhJF9ryzbUv9SBCg1YKIV1-AuEeIhY"
            });

            const body = {
                userId: user.id,
                subscription
            };

            const response = await fetch(process.env.VUE_APP_API_URL+'/push/subscribe', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    "Token": process.env.VUE_APP_API_KEY
                },
                body: JSON.stringify(body)
            });
            user = await response.json();
            if (!user) {
                console.warn('Something went wrong while subscribing to push notifications.');
                this.handleDenyPermission();
                return;
            } else {
                this.updateYou(user);
            }
            localStorage.setItem('subscriptionInitialized', true);
        },
        updateYou(user) {
            let you = localStorage.getItem('you');
            if (you) you = JSON.parse(you);
            else you = {};
            
            localStorage.setItem('you', JSON.stringify({ ...you, ...user }));
        },
    },
    created() {
        this.$root.$on('requestNotificationPermission', this.handleRequestNotificationPermission);
    },
    beforeDestroy() {
        this.$root.$off('requestNotificationPermission', this.handleRequestNotificationPermission);
    },
}
</script>

<style lang="scss" scoped>

</style>